import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import mpm from "assets/img/mpm.jpg";


import styles from "assets/jss/material-kit-react/views/mpm.js";
import { string } from "prop-types";
import Ads3 from "../../Main/Sections/Ads3.js";


const useStyles = makeStyles(styles);

export default function MPMMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
  
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg3.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={mpm} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>ماراتون های برنامه نویسی تلفن همراه</h3>
                                        <div className={classes.description}>
                                        <p>
                                        این رویداد معتبرترین و با سابقه ترین رویداد در حوزه برنامه نویسی تلفن همراه در سطح کشور می باشد و از سال 1392 تا کنون، 9 دوره این مسابقات در سطح کشور برگزار شده و تیم های برنامه نویسی متعددی را وارد بازار کار کرده است.
                                        </p>
                                        <p>
                                         در این مسابقات تیم های برنامه نویس 48 ساعت فرصت دارند تا نسخه اولیه یک برنامه تلفن همراه در حوزه های مشخص شده توسط کمیته ارتباط با صنعت مسابقه را به تیم داوری تحویل دهند. در کل این مدت تیم ها در محل برگزاری رویداد قرنطینه هستند و تیم های داوری و مشاور به صورت کامل بر نحوه عملکرد تیم ها نظارت میکنند. در انتها تیم های برتر با نظر داور ها به مرحله نهایی راه پیدا میکنند و فرصت دارن تا مجددا برنامه خود را برای داوران ارائه دهند.
                                        </p>
                                        </div>
                                    </div>
                                    <br />
                                    <p>
                                    <Button variant="outlined" target='_blank' href="http://mpm.sharif.ir"  disableElevation>
                                         وب سایت ماراتون های برنامه نویسی تلفن همراه
                                    </Button>
                                    <br />
                                    <br />
                                    <Button variant="outlined"  color="secondary" href="/Mpm/Event"  disableElevation>
                                         سامانه دهمین دوره ماراتون برنامه نویسی تلفن همراه کشور
                                    </Button>
                                    <br />
                                    <br /> 
                                    <Button variant="outlined" target='_blank' href="https://www.skyroom.online/ch/sharifcamp.ir/mpm10"  disableElevation>
                                    ورود به سالن همایش ماراتون برنامه نویسی تلفن همراه کشور
                                    </Button>
                                    </p>
                                </div>
                            </GridItem>
                           {
 //<Ads3></Ads3>
                           }

                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>اهداف برگزاری</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                    <ul className={classes.rightToLeft}>
                                        <li>شناسایی برنامه نویسان مستعد و برجسته کشور</li>
                                        <li>شناسایی ایده های بکر و خلاقانه</li>
                                        <li>ورود افراد مستعد به بازار کار</li>
                                    </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>آشنایی بیشتر</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                <Typography variant="h6" gutterBottom>
                                انتظار ما چیست ؟
      </Typography>
      <p>
با دیگر دوستان برنامه نویس، گرافیست و ایده پرداز خود، یک برنامه کاربردی موبایل طراحی و پیاده سازی کنید. ۴۸ ساعت فرصت دارید تا طرح اولیه ی پروژه ی مد نظر خود را ارائه دهید.
</p>
<br />
<br />

<Typography variant="h6" gutterBottom>
چه چیزی برایمان مهم است؟
      </Typography>
<p>
<strong>رابط کاربری</strong>: مطمئنا در ۴۸ ساعت نخواهید توانست بهترین کار خود را ارائه دهید یا تکمیل کنید، برای ما مهم این است که قدمهای اولیه را درست و با دلیل برداشته باشید، و بخشی از آنچه که در آینده خواهیم دید را به ما نشان دهید. مطمئنم قبول دارید که زیبایی یک برنامه مهم است، حتی اگر در مرحله ی دمو باشد.
</p>
<p>
<strong>کاربرد پذیری و تجربه کاربری</strong>: مهم است که کاربران بدانند چگونه از برنامه شما استفاده کنند، و این کار برایشان ساده و لذت بخش باشد. دسترسی به بخشهای مختلف، عملیاتها و امکانات برنامه آسان طراحی شده باشد تا کاربر احساس سردرگمی نکند، راحت و سریع به خواسته ی خود برسد و حس روی اعصاب بودن نداشته باشد. حتی المقدور به این موضوع فکر کنید، و برجسته ترین موارد را پیاده کنید، تا ما هم بتوانیم حس نهایی را تست کنیم.
</p>
<p>
<strong>خلاقیت</strong>: آنچه ما از داکیومنت های شما، نوشته هایتان و کد برنامه ی شما خواهیم دانست، این است که شما چقدر میتوانید خلاق باشید. شما با چالش هایی روبرو خواهید بود، میخواهیم بدانیم چگونه ساختار، راه حل و برنامه های خلاقانه برای مقابله با این چالش ها، چه در ایده پردازی، چه در کاربرد پذیری و یا کد برنامه خواهید یافت.
</p>
<p>
<strong>ایده پردازی</strong>: ایده ی خوب میبایست خوب پیاده شود. اما به هرحال قدم اول طرح ایده است. ایده ی خوب شرایط خاصی دارد، یا ایده ای نوآورانه است، یا ایده ی موجود بهبود داده شده. اما ایده ی خوب را با معیارهایی میتوان سنجید.
</p>
<p>
    <ul>
        <li>
        اینکه چه نیازی از مردم رفع میکند؟
        </li>
        <li>
        جامعه ی تحت پوشش چقدر بزرگ است؟
        </li>
        <li>
قابلیت گسترش دارد؟
        </li>
        <li>
روشهای درآمد زایی مناسب دارد؟
        </li>
        <li>
از نظر فنی در زمان معقول قابل انجام است؟
        </li>
        <li>
سطح دانش آن چقدر است، امکانات لازم آن وجود دارد؟
        </li>
        <li>
و …
        </li>
    </ul>
</p>
<p>
<strong>هدف پروژه و درآمد زایی</strong>: اکثرا پروژه ها یک یا چندین هدف را دنبال میکنند، آمده اند تا اطلاعاتی جمع آوری کنند، محصولی را بفروشند، تبلیغ کنند و …..
</p>
<p>
درمورد پروژه ی خود به روشهای درآمد زایی فکر کنید. لازم است به صورت جزیی بدانید که قرار است چه چیزی بدست بیاورید. نه اینکه فقط به این موضوع فکر کنید که برنامه یا سرویسی ایجاد کنید، در شروع کار شما میبایست به آنچه در آینده میخواهید نیز فکر کنید. لطفا به این موضوع اهمیت بیشتری دهید و خلاقیت به خرج دهید.
</p>
<p>
<strong>برنامه نویسی و پیاده سازی</strong>: روش کار تیمی شما، محیط برنامه نویسی، تکنولوژی های استفاده شده، ابزارهای به کار گرفته شده و در آخر کد نوشته شده و روش کد نویسی شما نیز برای ما اهمیت دارد، البته به اندازه ی ۴۸ ساعت کار و در مقایسه با دیگر شرکت کنندگان. همواره دلایلی برای آنچه انجام میدهید داشته باشید و آن را با ما در میان بگذارید، تا بدانیم شما چگونه فکر کرده اید، و چرا اینگونه عمل نموده اید.
</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>جزییات انجام پروژه</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                این مسابقه ، مسابقه برنامه نویسی موبایل خواهد بود. بنابراین وبسایت یا موارد مشابه مورد قبول نیست.
                                </p>
                                <p>
اگر برنامه شما نیاز به وب سرویس داشته باشد، در صورت لزوم و صلاح دید میبایست آن را نیز پیاده سازی کنید. امکانات لازم و دسترسی های مربوطه جهت آپلود در اختیار شما قرار داده خواهد شد.
</p>
                                <p>
در زبان برنامه نویسی و تکنولوژی های استفاده شده محدودیتی وجود ندارد، اما جهت استفاده از موارد خاص، با تیم داوری و برگزار کنندگان هماهنگ کنید، تا مطمئن باشید امکانات احتمالی مورد نیازتان نیز وجود داشته باشد. استفاده از جاوا اسکریپت، cross Platform ها، Html و … مانعی ندارد. توجه فرمایید که دلایل شما برای استفاده از هر زبان یا تکنولوژی برای ما مهم خواهد بود.
</p>
                                <p>
در تمام مراحل، ارائه آنچه انجام میدهید برایتان با اهمیت باشد. توجه شود که شما میبایست با آنچه که طراحی و پیاده سازی نموده اید، به دیگران نشان دهید که به چه می اندیشیده اید، چه کرده اید، و در آینده چه کاری میتوانید انجام دهید. بنابراین میتوانید از ابزارهای مختلف برای ارائه کارتان استفاده کنید. گزارش مختصری بنویسید، گراف ها و نمودار ها میتوانند اطلاعات زیادی را در زمان کوتاه منتقل کنند. اسلایدهای مناسب میتواند نمایش خوبی برای پروژه ی شما باشد. توجه کنید، که امکان دارد تیم شما برای مرحله پایانی انتخاب شود، شما میبایست روبروی حضار ایستاده و از طرحتان دفاع کنید، بنابراین به متن سخنرانی خود نیز فکر کنید. 
                                </p>
                                <p>
فرم های گزارشی از طرف تیم برگزاری در اختیارتان قرار خواهد گرفت، آنها را با دقت پر کنید، تا داوران قبل از مصاحبه با شما در جریان زیر و بم پروژه تان باشند. 
                                </p>
                                 </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>مراحل داوری </h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                    در طول ۴۸ ساعت تیم ها برنامه های خود را در یکی از حوزه ها طراحی و اجرا خواهند نمود. هر حوزه معیار داوری مربوط به خود را خواهد داشت، بنابراین روند تکمیل پروژه میبایست با در نظر داشتن این معیارها انجام شود تا بالاترین امتیازها کسب گردد. </p>
                                <p>
                                تیم اول داوری متشکل از دوستانی ست که هر کدام در موضوع خاصی از موضوع های بالا تخصص دارند.در طول فرآیند مسابقه، داورها به سراغ تک تک تیم ها رفته و علاوه بر دادن مشاوره های لازم و مشاهده فعالیت ها و دستاورد ها، با تیم ها درمورد روش کار صحبت کرده و به تدریج امتیازات هر تیم را ثبت میکنند. این افراد نرم افزار شما را با توجه به معیارهای حوزه ی انتخابی شما مورد بررسی قرار خواهند داد. امتیازات ثبت شده، بهترین تیم های هر حوزه را معرفی می کند. تا پایان مسابقه کسی از نتیجه ی این انتخاب با خبر نیست، بنابراین تیمها میبایست فرآیند تکمیل پروژه و موارد لازم دیگر را طبق روند گذشته ادامه دهند. در پایان ۴۸ ساعت و در مراسم اختتامیه، به تدریج اسامی تیم های راه یافته به مرحله دوم اعلام خواهد شد. هر تیم فرصت ۱۰ دقیقه ای برای ارائه ی آنچه که طراحی و پیاده سازی نموده است را دارد. تیم دوم داوری بر اساس معیارهای هر حوزه، رای های خود را ثبت خواهد کرد. امتیازات داوری مرحله اول به علاوه امتیازات داوری مرحله دوم برترین برترین ها را مشخص خواهد نمود.
                                </p>
                                 </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
